import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { setGenderSearch } from '../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';

const Interested = ({ nextPath = '/auth/looking-for', backPath = '/auth/your-gender' }) => {
    const savedInterest = useSelector(state => state.auth.genderSearch);
    const [selectedInterest, setSelectedInterest] = useState(savedInterest || '');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const interestOptions = [
        { value: 'F', label: t('interested.options.women') },
        { value: 'M', label: t('interested.options.men') },
        { value: 'ALL', label: t('interested.options.everyone') }
    ];

    const handleNext = () => {
        if (selectedInterest) {
            dispatch(setGenderSearch(selectedInterest));
            navigate(nextPath);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="container">
                    <div className="account-area style-2">
                        {/* Retour vers l'étape précédente de la logique du parcours (pas l'historique du navigateur : */}
                        {/* la redirection automatique de ProtectedAuthRoute peut remplacer l'historique réel) */}
                        <a href="#" onClick={(e) => { e.preventDefault(); navigate(backPath); }} className="back-btn">
                            <ChevronLeft className="icon" />
                        </a>
                        <div className="section-head ps-0">
                            <h2>{t('interested.title')}</h2>
                        </div>
                        <div className="radio style-3">
                            {interestOptions.map((option) => (
                                <label key={option.value} className="radio-label">
                                    <input
                                        type="radio"
                                        name="interest"
                                        checked={selectedInterest === option.value}
                                        onChange={() => setSelectedInterest(option.value)}
                                        aria-label={t('interested.ariaLabel', { interest: option.label })}
                                    />
                                    <span className="checkmark">                      
                                        <span className="text">{option.label}</span>                  
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer */}
            <div className="footer fixed bg-white p-b15">
                <div className="container">
                    <button 
                        onClick={handleNext}
                        className="btn btn-lg btn-gradient w-100 dz-flex-box btn-shadow rounded-xl"
                        disabled={!selectedInterest}
                    >
                        {t('interested.next')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Interested;
